const routes = [{
  path: '/claim/home',
  component: () => import('@/views/claim/home'),
  name: 'claim-home',
  meta: {
    title: '理赔管理'
  }
}, {
  path: '/claim/add',
  component: () => import('@/views/claim/add'),
  name: 'claim-add',
  meta: {
    title: '理赔管理/新增理赔信息'
  }
}, {
  path: '/claim/update/:id',
  component: () => import('@/views/claim/add'),
  name: 'claim-update',
  meta: {
    title: '理赔管理/修改理赔信息'
  }
}, {
  path: '/claim/detail/:id',
  component: () => import('@/views/claim/detail'),
  name: 'claim-detail',
  meta: {
    title: '理赔管理/理赔信息'
  }
}, {
  path: '/claim/analysis',
  component: () => import('@/views/claim/analysis'),
  name: 'claim-analysis',
  meta: {
    title: '送修比报表'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/claim.js